export default __webpack_public_path__ + "maps-examples-view-annotation-basic-thumbnail-960-557a22f1276c4b5f8256522fce337892.webp";